import React, { Component } from 'react';
import '../css/getListUbications.css';
import 'whatwg-fetch';
class getListUbications extends Component {
  constructor(props) {
    super(props);
    //this.mapRef = React.createRef();
    this.state = {
      list_ubicaciones : []
    }
  }
  get_go_to =(modulo_modal)=>{
    this.props.get_go_to(modulo_modal)
  }
  get_List_Ubicaciones =()=>{
    const url= this.props.dir_url + "webapp/getListUbicaciones";
    const token =  this.props.token
    const token_Client =  this.props.token_Client
    var obj = { accion:'findUbicaciones', token, token_Client};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        //console.log(data)
        this.setState({
          list_ubicaciones:data[0].msg
        })
      }else{
        this.setState({
          list_ubicaciones:[]
        })
      }
    })
    .catch(console.log)
  }
  get_eliminar_ubicacion =(id_ubicacion)=>{
    const url= this.props.dir_url + "webapp/getEliminarUbicaciones";
    const token =  this.props.token
    const token_Client =  this.props.token_Client
    var obj = { accion:'eliminarUbicaciones', token, token_Client,id_ubicacion};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        this.setState({
          list_ubicaciones:data[0].msg
        })
      }else{
        this.setState({
          list_ubicaciones:[]
        })
      }
    })
    .catch(console.log)
  }
  mostrarUbicaciones = () => {
    const list_ubicaciones = this.state.list_ubicaciones;
    const id_ubicacion = this.props.id_ubicacion
    if(list_ubicaciones.length === 0) return null;
    //console.log(list_ubicaciones)
    return (
      <React.Fragment>
        {list_ubicaciones.map(ubicacion => (
          <div key={ubicacion.id_ubicacion} className="grid-container-menu_list_ubication" >
            <div className="div_menu_1_list_ubication" onClick={ () => this.props.get_coordenadas(ubicacion.lat,ubicacion.lon,ubicacion.calle,Number(ubicacion.id_ubicacion),ubicacion.referencia)}>
              <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/9478791231582004484-128.png') }  />
            </div>
            <div className="lbl_menu_2_list_ubication" onClick={ () => this.props.get_coordenadas(ubicacion.lat,ubicacion.lon,ubicacion.calle,Number(ubicacion.id_ubicacion),ubicacion.referencia)}>
              <span className="span-global-link">{ubicacion.calle}</span>
            </div>
            <div className="lbl_menu_3_list_ubication" onClick={ () => this.get_eliminar_ubicacion(ubicacion.id_ubicacion)}>
              <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/14458160321582004493-128.png') }  />
            </div>
          </div>
        )) }

      </React.Fragment>
    )
    //console.log("id_subrubro");
  }
  render() {
    const id_ubicacion = this.props.id_ubicacion
    return (
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="grid-container-menu_list_ubication">
            <div className="div_menu_1_list_ubication">
              <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') }
              onClick={ () => this.props.get_go_to('')} />
            </div>
            <div className="lbl_menu_2_list_ubication">
              <span className="span-global-link">Lista de Ubicaciones</span>
            </div>
            <div className="lbl_menu_3_list_ubication">

            </div>
          </div>
          <div className="grid-container-menu_list_ubication" onClick={ () => this.props.get_coordenadas(localStorage.lat,localStorage.lon,"Ubicación Actual",0,'')}>
            <div className="div_menu_1_list_ubication">
              <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/9478791231582004484-128.png') }  />
            </div>
            <div className="lbl_menu_2_list_ubication">
              <span className="span-global-link">Ubicación Actual</span>
            </div>
            <div className="lbl_menu_3_list_ubication">
              {(Number(id_ubicacion)===0)?
              <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15808962761582004492-128.png') }  />
              :
              <React.Fragment></React.Fragment>
              }
            </div>
          </div>
          {this.mostrarUbicaciones()}
          <button style={{"width":"200px"}} className="button-global" onClick={ () => this.get_go_to("newubicacion")}>Nueva Ubicación</button>
        </div>
      </div>
    );
  }
  componentDidMount (){
    this.get_List_Ubicaciones();
  }
}
export default getListUbications;
